//A collection of functions that are used on mosh Vici web apps
//v0.1
const viciCommon = {
	//This will override console to log to lumberjack via a websocket
	//Call it with console = await viciCommon.initLogSocket('wss://lj.vicinft.com/lumberjack/ws', 'App Name');
	initLogSocket: async function(lumberjackLocation, appName){
		let resolver;
		const logSocket = new WebSocket(lumberjackLocation, "message");

		let bid = document.cookie.split("; ").find((row) => row.startsWith("bid="))?.split("=")[1];
		
		if(!bid){
			bid = viciCommon.randomString(32, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
			document.cookie = "bid="+bid+"; SameSite=None; Secure";
		}	
		
		logSocket.onopen = (event) => {
			console.log("Logsocket open")
			console = {
				log : function(msg) {logSocket.send(JSON.stringify({userAgent: window.navigator.userAgent, domain: window.location.hostname, path: window.location.pathname, app: appName, type: 'log', message: msg, bid: bid}))},
				info : function(msg) {logSocket.send(JSON.stringify({userAgent: window.navigator.userAgent, domain: window.location.hostname, path: window.location.pathname, app: appName, type: 'info', message: msg, bid: bid}))},
				warn : function(msg) {logSocket.send(JSON.stringify({userAgent: window.navigator.userAgent, domain: window.location.hostname, path: window.location.pathname, app: appName, type: 'warn', message: msg, bid: bid}))},
				error : function(msg) {logSocket.send(JSON.stringify({userAgent: window.navigator.userAgent, domain: window.location.hostname, path: window.location.pathname, app: appName, type: 'error', message: msg, bid: bid}))},
				debug : function(msg) {logSocket.send(JSON.stringify({userAgent: window.navigator.userAgent, domain: window.location.hostname, path: window.location.pathname, app: appName, type: 'debug', message: msg, bid: bid}))},
			};
			resolver(console);
		};

		return new Promise(resolve => {
			resolver = resolve;
		});
	},
	
	randomString: function(length, chars) {
		var result = '';
		for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
		return result;
	},

	sleep: function(ms){
		return new Promise(resolve => setTimeout(resolve, ms));
	},

	//Modal functions
	showModal: async function(modalHtml, hideClose){
		$('#modal_text').html(modalHtml);
		if(hideClose){
			$('#modal_close').hide();		
		}
		$('#modal_grey').show();
		$('#modal').show();
		$('#modal_close').click(hideModal)
	},
	
	hideModal: async function(){
		$('#modal_grey').hide();
		$('#modal').hide();
	},
	
	
	//Message display queue (toaster)
	//If you want to skip the full sleep time you can use nextMessage()
	//So the idea is to start with a long display time and then resolve early
	//If you call nextMessage(true) it will clear, even if there is nothing in the queue before
	//Otherwise it will keep showing
	sleepPromise: undefined, 
	sleepPromiseResolve: undefined, 
	sleepPromiseReject: undefined,
	sleepTimeout: undefined,
	messageSleeping: false,
	messages : [],
	messagesShowing : false,

	messageSleep: function(ms){
		this.messageSleeping = true;
		this.sleepPromise = new Promise(function(resolve, reject){
			viciCommon.sleepPromiseResolve = resolve;
			viciCommon.sleepPromiseReject = reject;
			viciCommon.sleepTimeout = setTimeout(viciCommon.sleepPromiseResolve, ms)
		}).finally(() =>{this.messageSleeping=false});
		return this.sleepPromise;
	},
	
	nextMessage: async function(clearMessage){
		if(!clearMessage || clearMessage!==true){
			if(this.messages.length<1) return;
		}
		if(this.messagesShowing){
			if(this.sleepPromiseResolve){
					while(this.messageSleeping===false){
					await this.sleep(100);
				}
				this.sleepPromiseResolve();
				clearTimeout(viciCommon.sleepTimeout);
			}else{
				while(this.sleepPromiseResolve==undefined){
					await this.sleep(100);
				}
				this.sleepPromiseResolve();
				clearTimeout(viciCommon.sleepTimeout);
			}
		}
	},
	
	addMessage: async function(message, type, ms){
		this.messages.push({message: message, type: type, ms: ms});
		if(this.messagesShowing===false){
			this.showMessages();
		}
	},
	
	showMessages: async function(){
		this.messagesShowing=true;
		let firstRun = true;
		let message = undefined;
		while(this.messages.length > 0){
			let message = this.messages.shift();
			$("#message").removeClass();
			$("#message").addClass(message.type);
			$('#message').html(message.message)		
			if(firstRun===true){
				await $('#message').fadeIn('slow').promise();
				firstRun = false;
				this.messagesShowing=true;//Back in from fade
			}
			await this.messageSleep(message.ms);
			if(this.messages.length === 0){
				await $('#message').fadeOut('slow').promise();			
				//If a new message comes in while we're fading out, we'll need to fade back in...
				this.messagesShowing=false;
				let firstRun = true;
			}
		}
	},
}

module.exports = viciCommon;